var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hero-body"},[_c('h1',{staticClass:"title has-text-primary has-text-centered"},[_vm._v(" "+_vm._s(_vm.$t("page-not-found"))+" ")]),_c('div',{staticClass:"has-text-centered"},[_vm._v(" "+_vm._s(_vm.$t("return-to-dashboard-message"))+" "),_c('router-link',{attrs:{"to":"/"}},[_vm._v(" "+_vm._s(_vm.$t("here"))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }